import { render, staticRenderFns } from "./ExcelObservacionesAuditoriasEtiquetas.vue?vue&type=template&id=108b9e36&scoped=true&"
import script from "./ExcelObservacionesAuditoriasEtiquetas.vue?vue&type=script&lang=js&"
export * from "./ExcelObservacionesAuditoriasEtiquetas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b9e36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
